import React from 'react';
import { useClassName } from 'common/hooks';
import { ContentfulRichText } from 'common/components';
import HomepageAsset from '../Asset';
import HomepageImage from 'public/screens/Home/Components/Image';
import Actions from '../Actions';
import Link from '../Link';
import './card.less';
import './card-m.less';

export default function CardTypeM({ item, refs, handleTrack }) {
  const classNames = useClassName('CLPCardTypeM');
  return (
    <div className={classNames('container')}>
      <HomepageAsset
        asset={item.fields.asset}
        settings={item.fields.settings}
      />
      <div className={classNames('content')}>
        {Boolean(item.fields.subtitle) && (
          <span>
            <HomepageImage field={item.fields.icon} /> {item.fields.subtitle}
          </span>
        )}
        <h3>{item.fields.title}</h3>
        <section>
          <ContentfulRichText field={{ 'en-US': item.fields.description }} />
        </section>
        {Boolean(item?.fields?.links?.length) && (
          <Actions className={classNames('actions')}>
            {item.fields.links.map((link) => (
              <Link
                key={link.sys.id}
                component={link}
                refs={refs}
                handleTrack={handleTrack}
              />
            ))}
          </Actions>
        )}
      </div>
    </div>
  );
}
